import { Users } from 'lucide-react'

export function TeamsEmptyState() {
  return (
    <div className='flex flex-col items-center justify-center h-full text-gray-500 space-y-4'>
      <div className='text-6xl'>
        <Users />
      </div>
      <div className='text-center'>
        <h3 className='text-lg font-medium mb-2'>No teams yet</h3>
        <p className='text-sm'>
          Create your first team to get started with team management.
        </p>
      </div>
    </div>
  )
}
